import { action, observable } from 'mobx';

export class CartLimitReachedModalController {
    @observable public shouldDisplayModal: boolean = false;
    @observable public maxSkuLimit: number = 0;

    @action public toggleModal(newState: boolean) {
        this.shouldDisplayModal = newState;
    }

    @action public handleSkuLimitReached(maxSkuLimit: number) {
        this.maxSkuLimit = maxSkuLimit;
        this.toggleModal(true);
    }
}
